import type { YmmField, YmmFormData } from '../api/types';
import { YMM_FIELDS } from './constants';

export type YmmFormState = {
  formData: YmmFormData;
  fieldState: {
    year: {
      current_field: string;
      current_val: string;
    };
    make: {
      current_field: string;
      current_val: string;
    };
    model: {
      current_field: string;
      current_val: string;
    };
  };
  isLoading: {
    year: boolean;
    make: boolean;
    model: boolean;
  };
  error: string | null;
  /** True after restoring from localStorage; cleared only when a form submits (Search). While true, setYear/setMake/setModel skip getOptionHtml. */
  preserveFromRestore: boolean;
  /** True when the upstream YMM service returns show_app: "disabled". All YMM UI should be hidden. */
  appDisabled: boolean;
  /** HTML message from the API when the app is disabled. */
  disabledMessage: string;
};

export function computePrevVal(
  fieldState: YmmFormState['fieldState'],
  changingField: 'year' | 'make' | 'model'
): string {
  const prevValues: string[] = [];

  // When changing year, no previous values
  if (changingField === 'year') {
    return fieldState.year.current_val;
  }

  // When changing make, include year
  if (changingField === 'make') {
    if (fieldState.year.current_val) {
      prevValues.push(fieldState.year.current_val);
      prevValues.push(fieldState.make.current_val);
    }
  }

  // When changing model, include year and make
  if (changingField === 'model') {
    prevValues.push(fieldState.year.current_val);
    prevValues.push(fieldState.make.current_val);
    prevValues.push(fieldState.model.current_val);
  }

  return prevValues.join(',');
}

export const initialState: YmmFormState = {
  formData: {
    year: {} as YmmField,
    make: {} as YmmField,
    model: {} as YmmField,
  },
  fieldState: {
    year: {
      current_field: YMM_FIELDS.YEAR,
      current_val: '',
    },
    make: {
      current_field: YMM_FIELDS.MAKE,
      current_val: '',
    },
    model: {
      current_field: YMM_FIELDS.MODEL,
      current_val: '',
    },
  },
  isLoading: {
    year: false,
    make: false,
    model: false,
  },
  error: null,
  preserveFromRestore: false,
  appDisabled: false,
  disabledMessage: '',
};
